export default __webpack_public_path__ + "static/media/Flag_of_Gambia.e274410d.svg";